import React from 'react';
import "./styles.css";
import { Grid } from 'antd';

const { useBreakpoint } = Grid;

const Footer = () => {
	const screens = useBreakpoint();
	const isSmall = screens.xs ? true : false;
	return(
		<div className="bup-footer-container">
		<div className="bup-footer__wrapper">
			{
				isSmall ? 
				(
					<h3 className="bup-footer-text">
						&copy; 2021 BRAVEUP
					</h3>
				) : 
				(
					<h3 className="bup-footer-text">
						&copy; 2021 BRAVEUP. Todos los derechos
						reservados
					</h3>
				)
			}
		</div>
	</div>
	)
}

export default Footer;